// src/pages/user/Hotels/ReservationCalendarPage.jsx

import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar'; // Install with: npm install react-calendar
import 'react-calendar/dist/Calendar.css';
import './ReservationCalendarPage.css'; // Add custom styles if needed
import axiosInstance from '../api/axiosInstance';
import { useAuth } from '../context/AuthContext';

const ReservationCalendarPage = () => {
  const { authData } = useAuth();
  const [reservations, setReservations] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReservations = async () => {
      if (!authData?.hotelId) {
        setError('Hotel ID is not available. Please log in again.');
        setLoading(false);
        return;
      }

      try {
        // Updated API endpoint to fetch reservations by Hotel ID
        const response = await axiosInstance.get(`/Reservations/ByHotel/${authData.hotelId}`);
        setReservations(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        console.error('Error fetching reservations:', err);
        setError(err.response?.data?.message || 'An error occurred while fetching reservations.');
      } finally {
        setLoading(false);
      }
    };

    fetchReservations();
  }, [authData?.hotelId]);

  const onDateChange = (date) => {
    setSelectedDate(date);
  };

  const renderReservationsForDate = (date) => {
    const dateString = date.toISOString().split('T')[0];
    const reservationsForDate = reservations.filter(
      (res) => res.checkInDate <= dateString && res.checkOutDate >= dateString
    );

    return reservationsForDate.length > 0 ? (
      <ul className="reservations-list">
        {reservationsForDate.map((res) => (
          <li key={res.reservationId}>
            Room: {res.roomId}, Guest: {res.guestName}, Status: {res.status}
          </li>
        ))}
      </ul>
    ) : (
      <p>No reservations for this date.</p>
    );
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="reservation-calendar-page">
      <h1>Reservation Calendar</h1>
      <Calendar
        onChange={onDateChange}
        value={selectedDate}
        tileContent={({ date }) => {
          const dateString = date.toISOString().split('T')[0];
          const hasReservations = reservations.some(
            (res) => res.checkInDate <= dateString && res.checkOutDate >= dateString
          );
          return hasReservations ? <div className="calendar-dot"></div> : null;
        }}
      />
      <div className="selected-date-details">
        <h2>Reservations for {selectedDate.toDateString()}</h2>
        {renderReservationsForDate(selectedDate)}
      </div>
    </div>
  );
};

export default ReservationCalendarPage;
